import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=aed5dad8&scoped=true"
var script = {}
import style0 from "./Process.vue?vue&type=style&index=0&id=aed5dad8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aed5dad8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aed5dad8')) {
      api.createRecord('aed5dad8', component.options)
    } else {
      api.reload('aed5dad8', component.options)
    }
    module.hot.accept("./Process.vue?vue&type=template&id=aed5dad8&scoped=true", function () {
      api.rerender('aed5dad8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/aboutUS/components/Process.vue"
export default component.exports